import {
  transferCODIntercityOrderFn,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export const useTransferCODIntercityOrder = (
  opts?: UseMutationOptions<any, DefaultQueryError, string>
) =>
  useMutation<any, DefaultQueryError, string>({
    mutationFn: transferCODIntercityOrderFn,
    ...opts,
  });
